import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { PlusSmIcon, MinusSmIcon } from '@heroicons/react/outline'
import { useState } from 'react'
import clsx from 'clsx'

const InputNumber = ({
    onChange,
    initialValue,
    label,
    required,
    className,
    extraLabel,
    incrementNumber = 1,
    min = 0,
    max = 10000,
}) => {
    const [value, setValue] = useState(initialValue || 1)
    const increment = incrementNumber || 1
    const isUpdatingFromProps = useRef(false)
    const isFirstRender = useRef(true)

    // Update internal state when initialValue changes (e.g., form reset)
    useEffect(() => {
        if (initialValue !== undefined && initialValue !== value) {
            isUpdatingFromProps.current = true
            setValue(initialValue)
        }
    }, [initialValue])

    useEffect(() => {
        // Skip onChange on first render
        if (isFirstRender.current) {
            isFirstRender.current = false
            return
        }

        if (isUpdatingFromProps.current) {
            isUpdatingFromProps.current = false
            return
        }
        onChange && onChange(value)
    }, [value])

    const handleIncrease = () => {
        if (max != null && min != null) {
            if (Number(value) >= Number(min) && Number(value) < Number(max)) {
                setValue(Number(value) + increment)
            }
        } else {
            setValue(Number(value) + increment)
        }
    }

    const hadleDecrease = () => {
        if (max != null && min != null) {
            if (
                Number(value) > Number(min) &&
                Number(value) <= Number(max) &&
                Number(value) != 0
            ) {
                setValue(Number(value) - increment)
            }
        } else {
            if (value != 1) {
                setValue(Number(value) - increment)
            }
        }
    }

    return (
        <div
            className={clsx(
                'h-auto flex flex-col items-start justify-starclsxt',
                className,
            )}
        >
            {label && (
                <label className="w-full h-auto text-textDarkerGray text-sm font-medium text-left">
                    {label}
                    {required && (
                        <span className="text-sm font-semibold text-error">
                            {' '}
                            *
                        </span>
                    )}
                </label>
            )}
            <div className="mt-2 overflow-hidden w-full flex flex-row items-center h-12 justify-between rounded-xl border border-grayLines">
                <button
                    className="px-4 py-3 rounded-none bg-pageBackground"
                    role="button"
                    type="button"
                    disabled={false}
                    onClick={hadleDecrease}
                >
                    <MinusSmIcon className="text-textDarkGray w-6 stroke-current stroke-2" />
                </button>

                <div className="text-textDarkerGray flex-grow flex items-center justify-center font-medium text-sm bg-white h-full w-20">
                    <p>{value}</p>
                    {extraLabel && <span className="ml-1">{extraLabel}</span>}
                </div>

                <button
                    className="px-4 py-3 rounded-none bg-pageBackground"
                    role="button"
                    type="button"
                    disabled={false}
                    onClick={handleIncrease}
                >
                    <PlusSmIcon
                        role="button"
                        className="text-textDarkGray w-6 stroke-current stroke-2"
                    />
                </button>
            </div>
        </div>
    )
}

InputNumber.propTypes = {
    onChange: PropTypes.func.isRequired,
    initialValue: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.any,
    ]),
    label: PropTypes.string,
    required: PropTypes.bool,
    className: PropTypes.string,
    extraLabel: PropTypes.string,
    incrementNumber: PropTypes.number,
    min: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.any,
        PropTypes.object,
    ]),
    max: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.any,
        PropTypes.object,
    ]),
    listenInitialValue: PropTypes.bool,
}

export default InputNumber
